const FIRST_PARTY_SOURCE_ENUM = {
    DISCOVERY: 1,
    UL_API: 2,
    DMP: 3,
  };
  
  const FIRST_PARTY_PERMISSION = 'first party segments';

  module.exports = {
    FIRST_PARTY_SOURCE_ENUM,
    FIRST_PARTY_PERMISSION,
  };